import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchClients(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/clients/list-all', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchClient(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/clients/view?id=${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addClient(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/clients/save', { ...userData })
          .then(response => {
            resolve(response)
          })

          .catch(error => reject(error.response))
      })
    },
    editClient(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/clients/edit', { ...userData })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error.response))
      })
    },
    serviceCall(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/clients/service-call', { ...userData })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error.response))
      })
    },
  },
}
